// DEPLOY: /var/www/woody.wtf/frontend/src/components/DiscordPush.js
// Admin-only "Push to Discord" button for one announcement, used on the
// Announcements and Company pages. POST /admin/discord-push posts it to the
// alerts channel exactly like an automatic alert, whatever the bot's rules and
// even if it was already sent - so it can be pressed as often as wanted.
// Callers only render it for admins; the route is @admin_required regardless.
import React, { useState } from 'react';
import api from '../api';

const btn = {
  fontFamily: "'DM Sans', sans-serif", fontSize: '11px', padding: '2px 8px', marginTop: '6px', cursor: 'pointer',
  border: '1px solid var(--accent)', borderRadius: 'var(--radius)', background: 'var(--surface)', color: 'var(--accent)',
};

export default function DiscordPush({ source, id }) {
  const [st, setSt] = useState('');       // '' | 'busy' | 'sent' | error text

  const push = e => {
    e.stopPropagation();                  // don't expand / collapse the summary it sits under
    setSt('busy');
    api.post('/admin/discord-push', { source, id })
      .then(() => setSt('sent'))
      .catch(err => setSt(err?.response?.data?.error || 'Failed'));
  };

  const failed = st && !['busy', 'sent'].includes(st);
  return (
    <button style={{ ...btn, ...(failed && { borderColor: 'var(--error)', color: 'var(--error)' }) }}
            disabled={st === 'busy'} onClick={push} title={failed ? st : 'Post this announcement to the Discord alerts channel'}>
      {st === 'busy' ? 'Pushing…' : st === 'sent' ? 'Pushed ✓ - push again' : failed ? 'Failed - retry' : 'Push to Discord'}
    </button>
  );
}
